import qs from "qs";
import { apiHelper } from "@/utils";
import { API } from "@/constants";

const API_URL = `${API.BASE_URL_API}/v1`;

export const esgDocumentService = { getAll, getSigningStatuses };

export function getSigningStatuses(documentUUID, isSigned) {
  return apiHelper(API_URL).get(
    `/esg-documents/${encodeURIComponent(documentUUID)}/signing-statuses`,
    { params: { is_signed: isSigned ? 1 : 0 } },
  );
}

export function getAll(filter = {}) {
  const params = {
    page: filter.pageNumber || 1,
    size: filter.pageSize || 15,
    sortBy: "created_at",
    orderBy: "desc",
  };
  if (filter.searchArray?.length) params.search_words = filter.searchArray;
  return apiHelper(API_URL).get("/esg-documents", {
    params,
    paramsSerializer: (query) =>
      qs.stringify(query, { arrayFormat: "brackets", encodeValuesOnly: true }),
  });
}
